var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99337 1.33334C4.31337 1.33334 1.33337 4.32001 1.33337 8.00001C1.33337 11.68 4.31337 14.6667 7.99337 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 7.99337 1.33334ZM10.1467 11.5933L8.00004 10.3L5.85337 11.5933C5.60004 11.7467 5.28671 11.52 5.35337 11.2333L5.92004 8.79334L4.03337 7.16001C3.81337 6.96668 3.93337 6.60001 4.22671 6.57334L6.72004 6.36001L7.69337 4.06001C7.80671 3.78668 8.19337 3.78668 8.30671 4.06001L9.28004 6.35334L11.7734 6.56668C12.0667 6.59334 12.1867 6.96001 11.96 7.15334L10.0734 8.78668L10.64 11.2333C10.7067 11.52 10.4 11.7467 10.1467 11.5933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeStar);
export default __webpack_public_path__ + "static/media/upgrade-star.aba864cf11e63e9b7c284b3a9a757029.svg";
export { ForwardRef as ReactComponent };